import { render } from "./ErrorDetails.vue?vue&type=template&id=58957b53"
import script from "./ErrorDetails.vue?vue&type=script&lang=js"
export * from "./ErrorDetails.vue?vue&type=script&lang=js"
script.render = render

export default script